export default "__VITE_ASSET__DGR4gZ9S__"